import { Base } from '@studiometa/js-toolkit';
import TableOfContentAnchor from './TableOfContentAnchor.js';

/**
 * @typedef {TableOfContent & {
 *   $options: {
 *     contentSelector: string,
 *   },
 *   $children: { TableOfContentAnchor: TableOfContentAnchor[] }
 * }} TableOfContentInterface
 */

/**
 * TableOfContent class.
 */
export default class TableOfContent extends Base {
  /**
   * Config.
   */
  static config = {
    name: 'TableOfContent',
    components: {
      TableOfContentAnchor,
    },
    options: {
      contentSelector: String,
    },
  };

  /**
   * Get active children.
   * @this {TableOfContentInterface}
   * @returns {TableOfContentAnchor[]}
   */
  get activeChildren() {
    return this.$children.TableOfContentAnchor.filter(
      (tableOfContentAnchor) => tableOfContentAnchor.isActive,
    );
  }

  /**
   * Get the first active child.
   * @returns {TableOfContentAnchor}
   */
  get firstActiveChild() {
    return this.activeChildren[0];
  }

  /**
   * Activate children.
   * @this {TableOfContentInterface}
   * @returns {void}
   */
  onTableOfContentAnchorShouldActivate() {
    this.$children.TableOfContentAnchor.forEach((child) => {
      child.toggle(child === this.firstActiveChild);
    });
  }
}
